import type { FaireProductEntity } from "../../entity_types/product";

export const p_p9hx4umsnb: FaireProductEntity = {
  token: "p_p9hx4umsnb",
  type: "product",
  name: "Yoga Flash Cards",
  brandToken: "b_pt47qddvxc",
  brandName: "Mindful and Co Kids USA",
  imageUrl:
    "https://cdn.faire.com/fastly/a746115ff163928a308a2abd2d8744f6eba6f25ab037ca72dcdb5fc89f27371a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc3177b66f7b45655e9b3838aeeb5999c4f95bfa321628e5c00f4213e4e0879a.jpeg",
    "https://cdn.faire.com/fastly/3acc94e272a15c080272a2f5992f9fa8402e4e326fa5ae0eeef197dfd5bc7203.jpeg",
    "https://cdn.faire.com/fastly/e6846d1967a7b68822c69b4eea4d0a2258e71da75e4ef5c1ab019e3cb3d50755.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "Nurture mindfulness in your child with our Yoga Flash Cards – expertly designed in Australia. Chloe Jasmine's hand-illustrated poses captivate young minds and encourage yoga practice wherever they go.\n\nExclusively created for Mindful & Co Kids, these flashcards display 26 poses, complete with explanations and benefits. Your little human will not only master yoga but share its magic with others.\n\nFeatures:\n\nAnxiety management\nEmotional regulation\nBody awareness\nBoosted self-esteem\nStrength and flexibility\nIdeal for home, school, daycare\nSustainable materials & packaging\nAges 18m+ to 10 years\n22 x 22 x 4cm.\n\nElevate their mindfulness journey with these enriching yoga flashcards, perfect for back-to-school and baby gifts. Order now to inspire a lifetime of wellness.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:06.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
